var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningAmberOutlined = function SvgWarningAmberOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "m12 6.49 7.53 13.01H4.47zm.865-2.495a1 1 0 0 0-1.73 0L1.869 19.999a1 1 0 0 0 .865 1.501h18.532a1 1 0 0 0 .865-1.501z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M13 16.5h-2v2h2zM13 10.5h-2v5h2z"
  })));
};
export default SvgWarningAmberOutlined;